@if ((currentView$ | async); as currentView) {
	<button
		type="button"
		class="icon-btn view-switcher"
		[class.ficon-app-grid]="currentView === views.LIST"
		[class.ficon-app-list]="currentView === views.GRID"
		[attr.data-cy]="currentView === views.LIST ? 'change-to-grid' : 'change-to-list'"
		[matTooltip]="(currentView === views.LIST ? 'change-to-grid-view' : 'change-to-list-view') | translate"
		matTooltipPosition="left"
		(click)="viewStateDataSource.toggleCurrentView()"></button>
}
